var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarlogo10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 80.4 80.4",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "39.7,7.2 27,27.6 52.5,72.1 79.3,72 65.7,50 14.3,50 1.1,72.3 26.1,72.3 52.9,27.2  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarlogo10);
export default __webpack_public_path__ + "static/media/carlogo (10).ff5401909535889968d12b5a517e8d2a.svg";
export { ForwardRef as ReactComponent };